//excel export
import React, { useContext, useEffect, useState } from "react";
import * as XLSX from "xlsx-js-style";
import { AuthContext, LoaderContext } from "../../Context/ContextFunctions";
import { FaFileExport, FaFilter } from "react-icons/fa";
import NoResultFoundModel from "../../components/common/NoDataFound";
import PaginationComponent from "../../components/common/PaginationModal";
import Select from "react-select";
import { CalenderFilterEnum, globalSelectStyles } from "../../middleware/enum";
import { GetClientLookupList } from "../../services/Client/ClientApi";
import CalendarFilter from "../../components/common/CalenderFilter";
import dayjs from "dayjs";
import { GetTenderReportList } from "../../services/Reports/ReportsApi";
import FilterDialog from "../../components/common/FilterDialog";
import FilterField from "../../components/common/FilterField";

export default function TenderReportListComponent() {
    //========================constant=======================
    const { userKeyID } = JSON.parse(localStorage.getItem("login"))
    const { setLoader } = useContext(LoaderContext);
    const { pageSize } = useContext(AuthContext);

    const tenderStatusList = [
        { label: "In Progress", value: 1 },
        { label: "Win", value: 2 },
        { label: "Lost", value: 3 },
    ];

    const tenderAmountList = [
        { label: "Processing Fee", value: 1 },
        { label: "Form Fee", value: 2 },
        { label: "EMD Payment", value: 3 },
        { label: "Security Deposit", value: 4 },
        { label: "Advance Security Deposit", value: 5 },
        { label: "Performance Security Deposit", value: 6 },
        { label: "Agreement Stamp Duty", value: 7 },
        { label: "Insurance Fee", value: 8 },
        { label: "GST Amount", value: 9 },
        { label: "TDS", value: 10 },
    ];

    // Maps display label → key in row data
    const feeColumnToDataKeyMap = {
        "Processing Fee": "processingFee",
        "Form Fee": "formFee",
        "EMD Payment": "emdPayment",
        "Security Deposit": "securityDeposit",
        "Advance Security Deposit": "advanceSecurity",
        "Performance Security Deposit": "performanceSecurity",
        "Agreement Stamp Duty": "agreementStamp",
        "Insurance Fee": "insuranceFee",
        "GST Amount": "gstAmount",
        "TDS": "tds",
    };

    // =================== Column Configs =====================
    const tableColumns = [
        //   { key: "expand", label: "" },
        { key: "__srno", label: "Sr. No." },
        { key: "tenderID", label: "Tender Id/Quotation No." },
        { key: "clientName", label: "Client Name" },
        { key: "bidDate", label: "Bid Date" },
        { key: "tenderStatus", label: "Tender Status" },
        { key: "tenderType", label: "Tender Type" },
    ];

    //========================state=======================
    const [valueSearch, setValueSearch] = useState(null)
    const [searchTimer, setSearchTimer] = useState(null)
    const [tableRows, setTableRows] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const [fromDate, setFromDate] = useState(dayjs().startOf("week"));
    const [toDate, setToDate] = useState(dayjs().endOf("week"));
    const [feeTotals, setFeeTotals] = useState({});
    const [expandedRows, setExpandedRows] = useState({});
    const [lookupList, setLookupList] = useState({
        clientList: [],
        projectList: [],
        employeeList: [],
    })
    const [appliedFilter, setAppliedFilter] = useState({
        userKeyID: userKeyID,
        pageNo: 0,
        pageSize: pageSize,
        sortingDirection: null,
        sortingColumnName: null,
        searchKeyword: null,
        fromDate: dayjs().startOf("week").format("YYYY-MM-DD"),
        toDate: dayjs().endOf("week").format("YYYY-MM-DD"),
        feeIDs: []
    })

    //filter state
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const [tempFilter, setTempFilter] = useState({
        clientID: null,
        statusID: null,
        feeIDs: [],
        fromDate: null,
        toDate: null
    });
    //========================useEffect=======================
    useEffect(() => {
        const fetchLookupData = async () => {
            setLoader(true);
            try {
                const [
                    clientRes,
                ] = await Promise.all([
                    GetClientLookupList(),
                ]);

                setLookupList({
                    clientList: mapToSelectOptions(
                        clientRes?.responseData?.data || [],
                        "clientName",
                        "clientID"
                    ),
                });
            } catch (error) {
                console.log("Lookup fetch error:", error);
            } finally {
                setLoader(false);
            }
        };
        fetchLookupData();
    }, []);

    useEffect(() => {
        async function fetchData() {
            setLoader(true);
            const response = await GetTenderReportList({
                ...appliedFilter,
            });
            setLoader(false);

            if (response?.statusCode == 200) {

                setTableRows(response.responseData.data);
                setTotalRecords(response?.totalRecords || response?.responseData?.data?.length || 0);
                setFeeTotals(response.responseData);
            } else {
                setTableRows([]);
                setTotalRecords(0);
            }
        }
        if (appliedFilter.fromDate && appliedFilter.toDate) fetchData();
    }, [appliedFilter]);
    //========================functions=======================

    const hasActiveFilters = () => {
        const {
            clientID,
            statusID,
            feeIDs,
            fromDate,
            toDate
        } = appliedFilter;

        return Boolean(
            clientID,
            statusID,
            feeIDs,
            fromDate,
            toDate
        );
    };

    //     const hasAnyFeeValue = tenderAmountList.some((fee) => {
    //   const dataKey = feeColumnToDataKeyMap[fee.label];
    //   const value = row[dataKey];
    //   return value && Number(value) !== 0;
    // });


    const mapToSelectOptions = (list = [], labelKey, valueKey) => {
        return list.map(item => ({
            label: item[labelKey],
            value: item[valueKey],
        }));
    };

    const toggleRow = (index) => {
        setExpandedRows(prev => ({
            ...prev,
            [index]: !prev[index]
        }));
    };

    const getLabelByValue = (list = [], value) => {
        return list.find(item => item.value === value)?.label || "";
    };

    const getCommaSeparatedLabels = (lookupList = [], selectedIds = []) => {

        if (!Array.isArray(lookupList) || !lookupList.length) return "-";
        if (!Array.isArray(selectedIds) || !selectedIds.length) return "-";

        // If feeIDs already contains objects
        if (typeof selectedIds[0] === "object") {
            return selectedIds.map(item => item.label).join(", ");
        }

        // feeIDs = [1,2,3]
        return lookupList
            .filter(item => selectedIds.includes(item.value))
            .map(item => item.label)
            .join(", ");
    };



    const handleJobExport = () => {
        const wb = XLSX.utils.book_new();
        const titleText = "Title: Tender Report";
        // 🔹 Build applied filter rows dynamically
        const filterRows = [];
        if (appliedFilter.clientID) {
            filterRows.push([
                "Client",
                getLabelByValue(lookupList.clientList, appliedFilter.clientID)
            ]);
        }

        if (appliedFilter.statusID) {
            filterRows.push([
                "Status",
                getLabelByValue(tenderStatusList, appliedFilter.statusID)
            ]);
        }
        if (Array.isArray(appliedFilter.feeIDs) && appliedFilter.feeIDs.length > 0) {
            filterRows.push([
                "Fee Type",
                getCommaSeparatedLabels(tenderAmountList, appliedFilter.feeIDs)
            ]);
        }

        if (appliedFilter.fromDate) {
            filterRows.push([
                "Start Date",
                appliedFilter.fromDate
            ]);
        }

        if (appliedFilter.toDate) {
            filterRows.push([
                "End Date",
                appliedFilter.toDate
            ]);
        }

        const headers = [
            "Tender Id/Quotation No.",
            "clientName",
            "Bid Date",
            "Tender Status",
            "Tender Type",
            'Processing Fee',
            'Form Fee',
            'EMD Payment',
            'Security Deposit',
            'Advance Security Deposit',
            'Performance Security Deposit',
            'Agreement Stamp Duty',
            'Insurance Fee',
            'GST Amount',
            'TDS'
        ];

        const data = tableRows.map((row) => [
            row.tenderID || "-",
            row.clientName || "-",
            row.bidDate || "-",
            row.tenderStatus || "-",
            row.tenderType || "-",
            row.processingFee || "-",
            row.formFee || "-",
            row.emdPayment || "-",
            row.securityDeposit || "-",
            row.advanceSecurity || "-",
            row.performanceSecurity || "-",
            row.agreementStamp || "-",
            row.insuranceFee || "-",
            row.gstAmount || "-",
            row.tds || "-",
        ]);

        const ws_data = [
            [titleText],
            [],
            ...(filterRows.length ? [["Applied Filters"]] : []),
            ...filterRows,
            ...(filterRows.length ? [[]] : []),
            [],
            headers,
            ...data
        ];

        const headerRowIndex =
            1 + 1 +
            (filterRows.length ? 1 + filterRows.length + 1 : 0) +
            1;


        const ws = XLSX.utils.aoa_to_sheet(ws_data);
        // Merge title row
        ws["!merges"] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: headers.length - 1 } }];
        ws["A1"].s = {
            font: { bold: true, sz: 14 },
            alignment: { horizontal: "left", vertical: "left" },
        };

        // Header row styling (row 2 / index 2)
        headers.forEach((_, col) => {
            const cellAddr = XLSX.utils.encode_cell({ c: col, r: headerRowIndex });
            if (ws[cellAddr]) {
                ws[cellAddr].s = {
                    font: { bold: true, color: { rgb: "000000" } },
                    alignment: { horizontal: "center", vertical: "center" },
                    fill: {
                        fgColor: { rgb: "D9E1F2" } // subtle header background
                    },
                    border: {
                        top: { style: "medium", color: { rgb: "000000" } },
                        bottom: { style: "medium", color: { rgb: "000000" } },
                        left: { style: "medium", color: { rgb: "000000" } },
                        right: { style: "medium", color: { rgb: "000000" } },
                    },
                };
            }
        });

        const dataStartRow = headerRowIndex + 1;

        // Data row styling
        for (let r = dataStartRow; r < data.length + dataStartRow; r++) {
            for (let c = 0; c < headers.length; c++) {
                const cellAddr = XLSX.utils.encode_cell({ c, r });

                if (ws[cellAddr]) {
                    ws[cellAddr].s = {
                        font: { color: { rgb: "000000" } },
                        alignment: {
                            horizontal: "center",
                            vertical: "center"
                        },
                        border: {
                            top: { style: "thin", color: { rgb: "000000" } },
                            bottom: { style: "thin", color: { rgb: "000000" } },
                            left: { style: "thin", color: { rgb: "000000" } },
                            right: { style: "thin", color: { rgb: "000000" } },
                        },
                    };

                    // Zebra rows
                    if ((r - dataStartRow) % 2 === 1) {
                        ws[cellAddr].s.fill = { fgColor: { rgb: "F7F7F7" } };
                    }
                }
            }
        }

        // Column widths for readability
        ws["!cols"] = headers.map((h) => ({ wch: h.length + 8 }));

        XLSX.utils.book_append_sheet(wb, ws, "Tender Report");
        XLSX.writeFile(wb, "Tender_Report.xlsx");
        setAppliedFilter({ ...appliedFilter, pageSize: pageSize })
    };

    const handleSearchFunction = (searchValue) => {
        setValueSearch(searchValue);

        // Clear old timer so API doesn't fire immediately
        if (searchTimer) clearTimeout(searchTimer);

        // Set new timer
        const timer = setTimeout(() => {
            setAppliedFilter({
                ...appliedFilter,
                searchKeyword: searchValue || null,
            });
        }, 500); // 500ms delay

        setSearchTimer(timer);
    };

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
        setAppliedFilter((prev) => ({ ...prev, pageNo: pageNumber - 1 }));
    }

    //=====================render table=====================
    const renderTable = (columns = [], data = []) => {
        if (!columns.length) return null;
        return (
            <div className="flex flex-col table_wrapper border border-gray-200">
                <div className="flex-1 ">
                    <table className="w-full border-collapse border border-gray-200 text-12 table-auto">
                        <thead>
                            <tr className="z-1 sticky top-0 bg-white">
                                {columns.map((col) => (
                                    <th
                                        key={col.key}
                                        className="text-12 border-b border-slate-200 bg-slate-50 whitespace-nowrap p-2"
                                    >
                                        {col.label}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {tableRows.length > 0 ? (
                                tableRows.map((row, index) => {
                                    const hasAnyFeeValue = tenderAmountList.some((fee) => {
                                        const dataKey = feeColumnToDataKeyMap[fee.label];
                                        const value = row[dataKey];
                                        return value && Number(value) !== 0;
                                    });
                                    const srNo = (currentPage - 1) * pageSize + index + 1;

                                    return (
                                        <React.Fragment key={index}>

                                            {/* MAIN ROW */}
                                            {/* <tr className="border-b border-slate-200 text-center"> */}
                                            <tr className="border-b border-slate-200 text-center bg-white hover:bg-slate-50 transition">
                                                {/* Expand button */}
                                                {/* <td className="px-2">
            <button
              onClick={() => toggleRow(index)}
              className="text-blue-600 hover:text-blue-800 text-sm"
            >
              {expandedRows[index] ? "−" : "+"}
            </button>
          </td> */}
                                                <td className="py-2 font-medium text-slate-700">
                                                    {srNo}
                                                </td>
                                                <td className="py-2">{row.tenderID || "-"}</td>
                                                <td>{row.clientName || "-"}</td>
                                                <td>{row.bidDate || "-"}</td>
                                                <td>{row.tenderStatus || "-"}</td>
                                                <td>{row.tenderType || "-"}</td>
                                            </tr>

                                            {/* EXPANDED FEES ROW */}
                                            {
                                                !expandedRows[index] && hasAnyFeeValue && (
                                                    <tr className="bg-slate-50">
                                                        <td colSpan={tableColumns.length} className="px-6 py-4">

                                                            {/* Divider */}
                                                            {/* <div className="border-t border-dashed border-slate-300 mb-4"></div> */}

                                                            {/* Fees Container */}
                                                            <div className="bg-white rounded-md shadow-sm border border-slate-200 px-4 py-3">
                                                                <div className="grid grid-cols-5 gap-x-6 gap-y-4 text-[12px]">
                                                                    {tenderAmountList.map((fee) => {
                                                                        const dataKey = feeColumnToDataKeyMap[fee.label];
                                                                        const value = row[dataKey] ?? 0;

                                                                        return (
                                                                            <div
                                                                                key={fee.label}
                                                                                className="flex flex-col"
                                                                            >
                                                                                <span className="text-slate-500 text-[11px] uppercase tracking-wide">
                                                                                    {fee.label}
                                                                                </span>
                                                                                <span className="font-semibold text-slate-900">
                                                                                    ₹ {Number(value).toLocaleString("en-IN")}
                                                                                </span>
                                                                            </div>
                                                                        );
                                                                    })}
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>

                                                )
                                            }
                                        </React.Fragment>
                                    )
                                })
                            ) : (
                                <tr>
                                    <td colSpan={tableColumns.length}>
                                        <NoResultFoundModel totalRecords={totalRecords} />
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div >

                {/* Pagination */}
                {
                    (tableRows?.length >= pageSize || currentPage != 1) && (
                        <div className="flex justify-end">
                            <PaginationComponent
                                totalPages={Math.ceil(totalRecords / pageSize)}
                                currentPage={currentPage}
                                onPageChange={handlePageChange}
                            />
                        </div>
                    )
                }
            </div >
        );
    };

    return (
        <div>
            <>
                <div className="bg-gray-50 mx-auto rep-width">
                    <div className="h-full bg-white shadow rounded-lg flex flex-col">
                        {/* Header Section */}

                        <div className="p-2 border-b flex flex-col lg:flex-row gap-3 items-start">
                            {/* Dropdown Filters */}
                            <FilterDialog
                                maxWidth="md"
                                fullWidth
                                open={isFilterOpen}
                                title="Tender Filters"
                                onClose={() => setIsFilterOpen(false)}
                                onSubmit={() => {
                                    setCurrentPage(1);
                                    setAppliedFilter(prev => ({
                                        ...prev,
                                        ...tempFilter,
                                        pageNo: 0,
                                        searchKeyword: null
                                    }));
                                    setIsFilterOpen(false);
                                }}
                            >

                                {/* Client filter */}
                                <FilterField label="Client">
                                    <Select
                                        options={lookupList.clientList}
                                        placeholder="Select Client"
                                        isClearable
                                        styles={globalSelectStyles}
                                        value={lookupList.clientList.find(
                                            opt => opt.value === tempFilter.clientID
                                        ) || null}
                                        onChange={async (option) => {
                                            setTempFilter(prev => ({
                                                ...prev,
                                                clientID: option?.value || null,
                                            }));

                                        }}
                                    />
                                </FilterField>

                                {/* Status Name Dropdown */}
                                <FilterField label="Status">
                                    <Select
                                        options={tenderStatusList}
                                        placeholder="Select Status"
                                        isClearable
                                        styles={globalSelectStyles}
                                        value={tenderStatusList.find(
                                            opt => opt.value === tempFilter.statusID
                                        ) || null}
                                        onChange={async (option) => {
                                            setTempFilter(prev => ({
                                                ...prev,
                                                statusID: option?.value || null,
                                            }));
                                        }}
                                    />
                                </FilterField>

                                {/* tender amount fields start  */}
                                <FilterField label="Fee Type">
                                    <Select
                                        options={tenderAmountList}
                                        placeholder="Select Fee Type"
                                        isClearable
                                        styles={globalSelectStyles}
                                        isMulti
                                        onChange={async (selectedOptions) => {
                                            // setListId({
                                            //     ...listId,
                                            //     feeIDs: selectedOptions ? selectedOptions.map((opt) => opt.value) : []
                                            // })
                                            setTempFilter({
                                                ...tempFilter,
                                                feeIDs: selectedOptions ? selectedOptions.map((opt) => opt.value) : []
                                            })
                                        }}
                                        value={tenderAmountList?.filter((item) => tempFilter?.feeIDs?.includes(item.value))}
                                    />
                                </FilterField>

                                {/* Date picker  */}
                                <FilterField label="Date">
                                    <CalendarFilter
                                        onDateChange={(fromDate, toDate) => {
                                            setFromDate(fromDate);
                                            setToDate(toDate);
                                            setCurrentPage(1);
                                            setTempFilter({
                                                ...tempFilter,
                                                fromDate: fromDate,
                                                toDate: toDate
                                            })
                                        }}
                                        toDate={toDate}
                                        setToDate={setToDate}
                                        fromDate={fromDate}
                                        setFromDate={setFromDate}
                                        hideAllOption={true} // Hide "All" option only here
                                        defaultSelectedOption={{
                                            value: CalenderFilterEnum.This_Week,
                                            label: "This Week",
                                        }} // Set default to "This Week"
                                    />
                                </FilterField>
                            </FilterDialog>

                            {/* Right-side: Export + Search */}
                            <div className="ml-auto flex items-center gap-2">
                                {/* Filter Button */}
                                <button
                                    onClick={() => {
                                        setIsFilterOpen(true);
                                        setTempFilter({ ...appliedFilter });
                                    }}
                                    className={`flex items-center gap-2 px-3 py-2 rounded border text-12 transition-all
                                                                 ${hasActiveFilters()
                                            ? "border-[#135EA0] text-[#135EA0] bg-blue-50"
                                            : "border-gray-300 text-gray-600 hover:border-[#135EA0]"
                                        }
                                     `}
                                >
                                    <FaFilter
                                        size={12}
                                        className={hasActiveFilters() ? "text-[#135EA0]" : "text-gray-500"}
                                    />
                                    <span>Filter</span>
                                </button>
                                {hasActiveFilters() && (
                                    <button
                                        type="button"
                                        className="flex items-center gap-2 px-3 py-2 rounded border border-red-300
                                             text-12 text-red-600 bg-red-50
                                             hover:border-red-400 hover:bg-red-100 transition-all"
                                        onClick={() => {
                                            setTempFilter({
                                                clientID: null,
                                                projectID: null,
                                                userID: null,
                                            });

                                            setAppliedFilter({
                                                ...appliedFilter,
                                                clientID: null,
                                                feeIDs: [],
                                                statusID: null,
                                                fromDate: dayjs().startOf("week").format("YYYY-MM-DD"),
                                                toDate: dayjs().endOf("week").format("YYYY-MM-DD"),
                                                pageNo: 0,
                                            });
                                        }}
                                    >
                                        Clear Filter
                                    </button>
                                )}
                                <button
                                    className="flex items-center gap-2 px-3 py-2 rounded border border-gray-300 text-12 text-gray-600 hover:border-[#135EA0] hover:text-[#135EA0]"
                                    onClick={() => {
                                        setAppliedFilter({
                                            ...appliedFilter,
                                            pageNo: 0,
                                            pageSize: 40
                                        });

                                        setTimeout(handleJobExport, 100);
                                    }}
                                >
                                    <FaFileExport size={12} />
                                    <span>Export</span>
                                </button>

                                {/* Search Input */}
                                <div className="relative w-[220px]">
                                    <input
                                        type="text"
                                        className="w-full border border-gray-200 text-12 shadow appearance-none rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline focus:ring-2 focus:ring-sky-600"
                                        placeholder="Search..."
                                        value={valueSearch}
                                        onChange={(e) => handleSearchFunction(e.target.value)}
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Tab Content */}
                        <div className="flex flex-col table_wrapper border border-gray-200">
                            <div className="flex-1 overflow-y-auto">
                                {renderTable(tableColumns, tableRows || [])}
                            </div>

                            {/* Pagination */}
                            {totalRecords > pageSize && (
                                <div className="flex justify-end ">
                                    <PaginationComponent
                                        totalPages={Math.ceil(totalRecords / pageSize)}
                                        currentPage={currentPage}
                                        onPageChange={handlePageChange}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </>
        </div>
    )
}
